import React, { Component } from 'react'
import './index.less'
import score from 'src/helper/score'
import { jumpToUser, jumpToRoom } from 'src/helper/webviewFun'

export default class extends Component {
  render() {
    let { lang, language, showRule, changeRule, historyList, ruleOrHis } = this.props
    return (
      <div className="rule-reminder-wrap">
        <div className="rule-reminder" style={{ display: `${showRule ? 'block' : 'none'}` }}>
          <div className="mask"></div>
          <div className="rule-box">
            <div className="head">
              {/* rule */}
              <div className="title" style={{ display: `${ruleOrHis == '0' ? 'block' : 'none'}` }}>
                {lang.rule}
              </div>
              {/* list */}
              <div className="title" style={{ display: `${ruleOrHis == '1' ? 'block' : 'none'}` }}>
                {lang.HonorList}
              </div>
              {/* reward-rule */}
              <div className="title" style={{ display: `${ruleOrHis == '2' ? 'block' : 'none'}` }}>
                {lang.rewardtitle}
              </div>
              <img src="/img/activity/pk/tbg.png" alt="" />
            </div>

            {/* rule */}
            <div className="body">
              <div className="show-rule" style={{ display: `${ruleOrHis == '0' ? 'block' : 'none'}` }}>
                <div>{lang.rule1}</div>
                <div>{lang.rule2}</div>
                <div>{lang.rule3}</div>
                <div>{lang.rule4}</div>
                <div>{lang.rule5}</div>
              </div>
              <div className="show-honor" style={{ display: `${ruleOrHis == '1' ? 'block' : 'none'}` }}>
                <div className="honor-list">
                  {historyList &&
                    historyList.length > 0 &&
                    historyList.map((list, index) => {
                      return (
                        <div className="item" key={index}>
                          <div className="b-title">
                            <img src="/img/activity/pk/time.png" alt="" />
                            <div className="time">{list.statdate}</div>
                          </div>
                          <div className="content">
                            <div className="s-item">
                              <div className="s-title">{lang.pkking}</div>
                              <div className="avatar" onClick={jumpToUser.bind(this, list.kingUserInfo.uid)}>
                                <img src={list.kingUserInfo.avatarurl} alt="" />
                              </div>
                              <div className="s-banner">{list.kingUserInfo.nickname}</div>
                              <div className="money">
                                <span>{score(list.kingUserInfo.value)}</span>
                                <img src="/img/activity/pk/bs.png" alt="" />
                              </div>
                            </div>
                            <div className="s-item">
                              <div className="s-title">{lang.supporter}</div>
                              <div className="avatar" onClick={jumpToUser.bind(this, list.boosterUserInfo.uid)}>
                                <img src={list.boosterUserInfo.avatarurl} alt="" />
                              </div>
                              <div className="s-banner">{list.boosterUserInfo.nickname}</div>
                              <div className="money">
                                <span>{score(list.boosterUserInfo.value)}</span>
                                <img src="/img/activity/pk/bs.png" alt="" />
                              </div>
                            </div>
                            <div className="s-item">
                              <div className="s-title">{lang.room}</div>
                              <div className="avatar" onClick={jumpToRoom.bind(this, list.groupInfo.gid)}>
                                <img src={list.groupInfo.logourl} alt="" />
                              </div>
                              <div className="s-banner">{list.groupInfo.name}</div>
                              <div className="money">
                                <span>{score(list.groupInfo.value)}</span>
                                <img src="/img/activity/pk/bs.png" alt="" />
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                </div>
              </div>
              <div
                className={`show-reward ${language == 'ar' ? 'arfz' : ''}`}
                style={{ display: `${ruleOrHis == '2' ? 'block' : 'none'}` }}
                dangerouslySetInnerHTML={{ __html: lang.rewardRule || '' }}
              >
              </div>
            </div>

            <div className="foot"></div>
            <div
              className="close"
              onClick={() => {
                changeRule({ state: false, value: "3" })
              }}
            ></div>
          </div>
        </div>
      </div >
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/pkactivity/RuleReminder/index.js